module.exports = __webpack_public_path__ + "static/media/correct-icon.b5e79bde.svg";